export const uploadAttachmentTransformer = (data) => {
    try {
        const payload = JSON.parse(data);
        return payload.AttachmentFilenames;
    } catch (error) {
        // swallow and return the payload as-is so axios can handle it.
    }
    return data;
};
